import isNull from 'lodash/isNull';

export function displayMetric(metric: number | null, percentage: boolean = false): string {
    if (isNull(metric)) return 'N/A';

    if (percentage) {
        return `${Math.round(metric * 100).toLocaleString()} %`;
    }

    return Math.round(metric).toLocaleString();
}
